export default "__VITE_ASSET__D0fWTk_v__"